<template>
    <div class="relative inline-block text-left">
        <button
            @click.stop="isOpen = !isOpen"
            class="flex items-center justify-center w-10 h-10 rounded-full bg-[#F2F3F3] hover:bg-slate-50 transition-all duration-200 shadow-sm focus:outline-none"
            type="button"
        >
            <Globe color="#191D41" />
        </button>

        <!-- Dropdown menu -->
        <div
            v-if="isOpen"
            class="absolute right-0 mt-2 w-28 rounded-xl bg-white shadow-xl border border-slate-100 z-[100] overflow-hidden"
        >
            <div class="py-1">
                <button
                    @click="changeLanguage('fr')"
                    class="flex items-center w-full px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
                    :class="{ 'bg-slate-50 font-bold text-primary': $i18n.locale === 'fr' }"
                >
                    <flag iso="fr" :squared="false" class="mr-2 text-base" /> FR
                </button>
                <button
                    @click="changeLanguage('en')"
                    class="flex items-center w-full px-4 py-2.5 text-sm text-slate-700 hover:bg-slate-50 transition-colors"
                    :class="{ 'bg-slate-50 font-bold text-primary': $i18n.locale === 'en' }"
                >
                    <flag iso="us" :squared="false" class="mr-2 text-base" /> EN
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { Globe } from 'lucide-vue'

export default {
    name: 'LanguageSwitcher',
    components: {
        Globe,
    },
    data() {
        return {
            isOpen: false,
        }
    },
    created() {
        const savedLocale = localStorage.getItem('locale')
        if (savedLocale && this.$i18n.locale !== savedLocale) {
            this.$i18n.locale = savedLocale
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick)
    },
    methods: {
        changeLanguage(lang) {
            this.$i18n.locale = lang
            localStorage.setItem('locale', lang)
            this.isOpen = false
        },
        handleOutsideClick(e) {
            if (this.isOpen && !this.$el.contains(e.target)) {
                this.isOpen = false
            }
        },
    },
}
</script>

<style scoped>
.text-primary {
    color: #7d2dbd;
}
</style>
